import { createSlice } from "@reduxjs/toolkit";
import {
  addApiCases,
  createDynamicThunk,
} from "../../../../service/requestHandler";

// Overview API: /report/api/v1/regulatoryCompliance/overview/{policyType}
// Payload: { accountNames: [...], cspList: [...] }
// Returns: { legends: [...], cspList: [{ csp, totalCompliance, ... }] }
export const fetchRegulatoryOverview = createDynamicThunk(
  "regulatoryOverview/fetch",
  "/report/api/v1/regulatoryCompliance/overview",
  ["policyType"]
);

export const initialState = {
  overviewData: null,
  overviewDataLoading: false,
};

export const RegulatoryOverviewSlice = createSlice({
  name: "RegulatoryOverviewSlice",
  initialState,
  reducers: {
    resetOverview: () => initialState,
  },
  extraReducers: (builder) => {
    addApiCases(builder, fetchRegulatoryOverview, "overviewData");
  },
});

export const { resetOverview } = RegulatoryOverviewSlice.actions;
export default RegulatoryOverviewSlice.reducer;
